export const FIELDSETS_TO_EXCLUDE = ['volunteer', 'freelance'];

export const EXCLUDE_FIELDSETS_MAP = {
  YC_DE: FIELDSETS_TO_EXCLUDE,
  NJ_DE: FIELDSETS_TO_EXCLUDE,
  SJ_DE: FIELDSETS_TO_EXCLUDE,
  SJ_FR: FIELDSETS_TO_EXCLUDE,
  SJ_BE: FIELDSETS_TO_EXCLUDE,
  SJ_ES: FIELDSETS_TO_EXCLUDE,
  SJ_SE: FIELDSETS_TO_EXCLUDE,
  SJ_UK: FIELDSETS_TO_EXCLUDE,
  SJ_AT: FIELDSETS_TO_EXCLUDE,
  SJ_CH: FIELDSETS_TO_EXCLUDE,
  SJ_IE: FIELDSETS_TO_EXCLUDE,
  SJ_BE_FR: FIELDSETS_TO_EXCLUDE
};

export const LEGAL_AGE_VALUE = {
  YC_DE: 16,
  YC: 13
};
